import moment from 'moment-timezone';

import { PaymentDueTermsAll } from '~components/business-owner/customers/invoices/constants';

import { INVOICE_PAYMENT_STATUS } from '~constants/invoice';
import { splitEmailsString } from '~utils/formatters/splitEmailsString';
import { validateEmail } from '~utils/validation/validateEmail';

export const capitalizeWord = (string = '') =>
	string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

/**
 * Formats date in UTC Timezone
 * @param {string | Date | null | undefined} date
 * @param format
 * @returns {string} formatted date
 */
export const formatDate = (date, format = 'MM/DD/YYYY') =>
	date ? moment.utc(date).format(format) : '';

/**
 * Formats date in Local Timezone
 * @param {string | Date | null | undefined} date
 * @param format
 * @returns {string} formatted date
 */
export const formatDateInLocalTimezone = (date, format = 'MM/DD/YYYY') =>
	date ? moment(date).format(format) : '';

export const formatCurrency = (number) => `$${(number || 0).toFixed(2)}`;

export const validateEmailsString = (str, maxEmails = 5) => {
	if (!str || str.length === 0) {
		return {
			isError: true,
			errorText: 'At least 1 email address required',
		};
	}

	const splittedStr = splitEmailsString(str);

	if (splittedStr.length > maxEmails) {
		return {
			isError: true,
			errorText: `Maximum ${maxEmails} email addresses`,
		};
	}

	if (splittedStr.length === 0) {
		return {
			isError: true,
			errorText: 'Minimum 1 email address',
		};
	}

	const isEveryEmailValid = splittedStr.every(validateEmail);

	if (!isEveryEmailValid) {
		return {
			isError: true,
			errorText: 'Provide correct emails',
		};
	}

	return {
		isError: false,
		errorText: '',
	};
};

export const getPaymentStatuses = (tab) => {
	if (tab === 'UNPAID') {
		return [
			INVOICE_PAYMENT_STATUS.UNPAID,
			INVOICE_PAYMENT_STATUS.PENDING,
			INVOICE_PAYMENT_STATUS.PARTIALLY_PAID,
		];
	}

	return [INVOICE_PAYMENT_STATUS.PAID];
};

export const getNumbersFromString = (value) => value.replace(/\D+/g, '');

export const getCustomDueDateISOFromInvoice = ({
	paymentDueTerms,
	paymentDueDate,
	datesTimeZone,
}) => {
	if (paymentDueTerms !== PaymentDueTermsAll.CUSTOM_DATE) {
		return null;
	}

	if (!paymentDueDate) {
		return paymentDueDate;
	}

	const paymentDueDateWithoutUTCIdentifier = paymentDueDate.replace(/Z/gi, '');

	/**
	 * `paymentDueDate` is already converted to business timezone = datesTimeZone
	 */
	return moment.tz(paymentDueDateWithoutUTCIdentifier, datesTimeZone).toISOString();
};
